// @scripts
import { IUserState } from './types';

export const getAttributes = (user: any, userName: string): IUserState => {
  const userAtributtes = (user?.signInUserSession?.idToken?.payload || user.attributes || user.challengeParam.userAttributes)['custom:site_ids'] || '';
  const response: IUserState = {
    userName,
    siteIds: !userAtributtes ? [] : userAtributtes.split(',').map((x:string) => +x),
    challengeName: user.challengeName === 'NEW_PASSWORD_REQUIRED',
    jwtToken: user?.signInUserSession?.idToken?.jwtToken
  };
  return response;
};
